export default [
  {
    keyQ: 'question1',
    keyA: 'answer1',
    question: '',
    answer: '',
  },
  {
    keyQ: 'question2',
    keyA: 'answer2',
    question: '',
    answer: '',
  },
  {
    keyQ: 'question3',
    keyA: 'answer3',
    question: '',
    answer: '',
  },
  {
    keyQ: 'question4',
    keyA: 'answer4',
    question: '',
    answer: '',
  },
]
